import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  OTP_FORGET_PASSWORD,
  OTP_FORGET_PASSWORD_ERROR,
  OTP_FORGET_PASSWORD_SUCCESS,
  STAFF_FORGET_PASSWORD,
  STAFF_FORGET_PASSWORD_ERROR,
  STAFF_FORGET_PASSWORD_SUCCESS,
  STAFF_OTP_FORGET_PASSWORD,
  STAFF_OTP_FORGET_PASSWORD_ERROR,
  STAFF_OTP_FORGET_PASSWORD_SUCCESS,
} from "./actionTypes";

export const staffForgetPasswordWithOTP = (user, history) => {
  return {
    type: STAFF_OTP_FORGET_PASSWORD,
    payload: { user, history },
  };
};

export const staffForgetPasswordSuccessWithOTP = message => {
  return {
    type: STAFF_OTP_FORGET_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const staffForgetPasswordErrorWithOTP = message => {
  return {
    type: STAFF_OTP_FORGET_PASSWORD_ERROR,
    payload: message,
  };
};

export const userForgetPasswordWithOTP = (user, onSuccess = () => {}, onError = () => {}, headers) => {
  return {
    type: OTP_FORGET_PASSWORD,
    payload: { user, onSuccess, onError, headers },
  };
};

export const userForgetPasswordSuccessWithOTP = message => {
  return {
    type: OTP_FORGET_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const userForgetPasswordErrorWithOTP = message => {
  return {
    type: OTP_FORGET_PASSWORD_ERROR,
    payload: message,
  };
};

export const staffForgetPassword = (user, history) => {
  return {
    type: STAFF_FORGET_PASSWORD,
    payload: { user, history },
  };
};

export const staffForgetPasswordSuccess = message => {
  return {
    type: STAFF_FORGET_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const staffForgetPasswordError = message => {
  return {
    type: STAFF_FORGET_PASSWORD_ERROR,
    payload: message,
  };
};

export const userForgetPassword = (user, onSuccess = () => {}, onError = () => {}) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, onSuccess, onError },
  };
};

export const userForgetPasswordSuccess = message => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  };
};
